const getContactEmail = () => document.querySelector('[data-contact-email]')?.dataset.contactEmail || 'info@metatronquantum.com';

const getCopy = () => {
  const english = document.querySelector('[data-language]')?.dataset.language === 'en';
  return english ? {
    selected: (number) => `You have selected the ${number}-session program as your starting point.`,
    subject: (number) => `Online assessment · ${number}-session program`,
    body: (number) => `Hello, I would like to receive information about the MetatronQuantum® ${number}-session online program.`,
    incomplete: 'Select one answer for each question.',
    detail10: 'Based on your answers, a comprehensive pathway may make it easier to connect the different areas.',
    detail5: 'Based on your answers, you can begin with one specific priority and then review whether an extension would be helpful.',
    detailRegenera: 'Because fatigue and low energy are your main priority, this focused 8-session program may be the most coherent starting point.',
    orientation: (number) => `Guidance: ${number}-session program.`,
    orientationRegenera: 'Guidance: Regenerate Your Mitochondria.',
    selectedRegenera: 'You have selected Regenerate Your Mitochondria as your starting point.',
    subjectRegenera: 'Information · Regenerate Your Mitochondria',
    bodyRegenera: 'Hello, I would like to receive information about the 8-session Regenerate Your Mitochondria online program.',
    view: 'View this option',
    viewRegenera: 'View this program'
  } : {
    selected: (number) => `Has seleccionado el programa de ${number} sesiones como punto de partida.`,
    subject: (number) => `Valoración online · Programa de ${number} sesiones`,
    body: (number) => `Hola, me interesa recibir información sobre el programa online de ${number} sesiones de MetatronQuantum®.`,
    incomplete: 'Selecciona una opción en cada pregunta.',
    detail10: 'Por lo que indicas, un recorrido integral permitiría relacionar mejor las distintas áreas.',
    detail5: 'Por lo que indicas, puedes empezar abordando una prioridad concreta y revisar después si necesitas ampliar.',
    detailRegenera: 'Como la fatiga y la falta de energía son tu prioridad principal, este programa específico de 8 sesiones puede ser el punto de partida más coherente.',
    orientation: (number) => `Orientación: programa de ${number} sesiones.`,
    orientationRegenera: 'Orientación: Regenera tu mitocondria.',
    selectedRegenera: 'Has seleccionado Regenera tu mitocondria como punto de partida.',
    subjectRegenera: 'Información · Regenera tu mitocondria',
    bodyRegenera: 'Hola, me interesa recibir información sobre el programa online Regenera tu mitocondria de 8 sesiones.',
    view: 'Ver esta opción',
    viewRegenera: 'Ver este programa'
  };
};

const selectProgram = (number, shouldScroll = false) => {
  const value = String(number);
  const tabs = [...document.querySelectorAll('[data-program-tab]')];
  const panels = [...document.querySelectorAll('[data-program-panel]')];
  const selectionCopy = document.querySelector('[data-selection-copy]');
  const contactLink = document.querySelector('[data-contact-link]');
  const copy = getCopy();

  tabs.forEach((tab) => tab.setAttribute('aria-selected', String(tab.dataset.programTab === value)));
  panels.forEach((panel) => { panel.hidden = panel.dataset.programPanel !== value; });

  if (selectionCopy) selectionCopy.textContent = copy.selected(value);
  if (contactLink) {
    const subject = encodeURIComponent(copy.subject(value));
    const body = encodeURIComponent(copy.body(value));
    contactLink.href = `mailto:${getContactEmail()}?subject=${subject}&body=${body}`;
  }

  if (shouldScroll) document.querySelector('#programas')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

const selectRegenera = (shouldScroll = false) => {
  const copy = getCopy();
  const selectionCopy = document.querySelector('[data-selection-copy]');
  const contactLink = document.querySelector('[data-contact-link]');

  if (selectionCopy) selectionCopy.textContent = copy.selectedRegenera;
  if (contactLink) {
    const subject = encodeURIComponent(copy.subjectRegenera);
    const body = encodeURIComponent(copy.bodyRegenera);
    contactLink.href = `mailto:${getContactEmail()}?subject=${subject}&body=${body}`;
  }

  if (shouldScroll) document.querySelector('.signature-program')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
};

const updateRecommendation = () => {
  const recommendation = document.querySelector('[data-recommendation]');
  if (!recommendation) return;
  const copy = getCopy();
  const energy = document.querySelector('input[name="energy"]:checked')?.value;
  const scope = document.querySelector('input[name="scope"]:checked')?.value;
  const time = document.querySelector('input[name="time"]:checked')?.value;
  if (!energy || !scope || !time) {
    recommendation.innerHTML = `<p>${copy.incomplete}</p>`;
    return;
  }
  if (energy === 'fatigue') {
    recommendation.innerHTML = `<p><strong>${copy.orientationRegenera}</strong> ${copy.detailRegenera} <button type="button" data-use-regenera>${copy.viewRegenera}</button></p>`;
    return;
  }
  const number = scope === 'broad' || time === 'deep' ? '10' : '5';
  const detail = number === '10' ? copy.detail10 : copy.detail5;
  recommendation.innerHTML = `<p><strong>${copy.orientation(number)}</strong> ${detail} <button type="button" data-use-recommendation="${number}">${copy.view}</button></p>`;
};

window.addEventListener('scroll', () => {
  document.querySelector('[data-header]')?.classList.toggle('scrolled', window.scrollY > 24);
}, { passive: true });

document.addEventListener('click', (event) => {
  const menuToggle = event.target.closest('[data-menu-toggle]');
  if (menuToggle) {
    const menu = document.querySelector('[data-menu]');
    const open = menuToggle.getAttribute('aria-expanded') === 'true';
    menuToggle.setAttribute('aria-expanded', String(!open));
    menu?.classList.toggle('open', !open);
    return;
  }

  const navLink = event.target.closest('[data-menu] a');
  if (navLink) {
    document.querySelector('[data-menu]')?.classList.remove('open');
    document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
    return;
  }

  const disclosure = event.target.closest('[data-disclosure]');
  if (disclosure) {
    const content = document.getElementById(disclosure.getAttribute('aria-controls'));
    const expanded = disclosure.getAttribute('aria-expanded') === 'true';
    disclosure.setAttribute('aria-expanded', String(!expanded));
    if (content) content.hidden = expanded;
    return;
  }

  const tab = event.target.closest('[data-program-tab]');
  if (tab) {
    selectProgram(tab.dataset.programTab);
    return;
  }

  const choose = event.target.closest('[data-choose]');
  if (choose) {
    selectProgram(choose.dataset.choose);
    document.querySelector('.closing')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return;
  }

  const recommended = event.target.closest('[data-use-recommendation]');
  if (recommended) {
    selectProgram(recommended.dataset.useRecommendation, true);
    return;
  }

  const regenera = event.target.closest('[data-use-regenera]');
  if (regenera) {
    selectRegenera(true);
    return;
  }

});

document.addEventListener('change', (event) => {
  if (event.target.matches('.decision-steps input')) updateRecommendation();
});

document.addEventListener('keydown', (event) => {
  const tab = event.target.closest?.('[data-program-tab]');
  if (!tab || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
  const tabs = [...document.querySelectorAll('[data-program-tab]')];
  event.preventDefault();
  const current = tabs.indexOf(tab);
  const next = ['ArrowRight', 'ArrowDown'].includes(event.key) ? (current + 1) % tabs.length : (current - 1 + tabs.length) % tabs.length;
  tabs[next]?.focus();
  if (tabs[next]) selectProgram(tabs[next].dataset.programTab);
});
